import styled from "styled-components";

export const CenterContainerWrapper = styled.section`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  h1 {
    box-sizing: border-box;
    padding: 0;
    font-size: 28px;
    color: rgb(40, 55, 82);
    letter-spacing: 1.4px;
    line-height: 40px;
    text-align: center;
    margin: 40px 0;
    font-weight: bold;
  }
`;
